import {Component, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {DevLogger} from 'src/app/shared/dev-logger';
import {ShopCartWrapperComponent} from "./shop-cart-wrapper";
import {ActiveSaleActionButtonsWrapperComponent} from "./active-sale-action-buttons-wrapper";
import {ActiveSaleBase} from './active-sale-base/active-sale-base.component';
import {ActiveSaleHeaderInfoWrapperComponent} from "./active-sale-header-info-wrapper/active-sale-header-info-wrapper.component";
import { PaymentsListWrapperComponent } from '../cashregister-payments/payments-list-wrapper/payments-list-wrapper.component';
import { PaymentsActionButtonsComponent } from '../cashregister-payments/payments-action-buttons/payments-action-buttons.component';

@Component({
    selector: 'app-active-sale',
    standalone: true,
    templateUrl: './active-sale.component.html',
    styleUrls: ['./active-sale.component.scss'],
    imports: [
        CommonModule,
        TranslateModule,
        ShopCartWrapperComponent,
        ActiveSaleActionButtonsWrapperComponent,
        ActiveSaleHeaderInfoWrapperComponent,
        PaymentsActionButtonsComponent,
        PaymentsListWrapperComponent
    ],
    host: {
        class: 'tw-flex tw-flex-col tw-gap-3 tw-h-full'
    }
})
export class ActiveSaleComponent extends ActiveSaleBase implements OnInit,OnDestroy {
    protected sideKeyboard = this.cashregisterStateService.sideKeyboard;

    public log(...arg: any[]) {
        DevLogger.debug('ACTIVE_SALE: ', ...arg)
    }

    // START - LIFECYCLE
    async ngOnInit() {
        await super.ngOnInit();
      }

    ngOnDestroy() {
       super.ngOnDestroy();
    }
    // END - LIFECYCLE

}
